module.exports = __webpack_public_path__ + "static/barber-logo-2aac67232494a0f11d55dcae0b2de932.png";